module.exports = __webpack_public_path__ + "img/meme_11.eaa1574e.jpg";